<button mat-menu-item (click)="viewInFirestore(this.patient())">
  <mat-icon>open_in_new</mat-icon>
  <span>View in Firestore</span>
</button>
